import Vue from "vue";
import Vuex from "vuex";
import appActions from './appActions.js';
import auth from './auth.js';
import document from './documents.js';

Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function (/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
      appActions,
      auth,
      document
    }
  })
  return Store
}